"use client";

import { useRouter } from "next/navigation";
import { useLocale } from "@/lib/locale-context";
import { useMemo } from "react";

export function useLocalizedRouter() {
  const router = useRouter();
  const { locale } = useLocale();
  return useMemo(() => ({
    ...router,
    push: (href: string, opts?: Parameters<typeof router.push>[1]) => {
      const prefixed = href.startsWith("/") ? `/${locale}${href}` : href;
      router.push(prefixed, opts);
    },
    replace: (href: string, opts?: Parameters<typeof router.replace>[1]) => {
      const prefixed = href.startsWith("/") ? `/${locale}${href}` : href;
      router.replace(prefixed, opts);
    },
  }), [router, locale]);
}
